import { dataUriToBlob } from "./download.util";

/**
 * Copies an image data URI to the clipboard via the async Clipboard API.
 * Rejects when the browser lacks image-clipboard support or the copy fails,
 * so callers can fall back (e.g. prompt the user to download instead).
 *
 * @param dataUri An image data URI, e.g. "data:image/png;base64,....".
 */
export function copyImageToClipboard(dataUri: string): Promise<void> {
    const blob = dataUriToBlob(dataUri);
    const clipboard: any = (navigator as any).clipboard;
    const clipboardItem: any = (window as any).ClipboardItem;

    if (!blob || !clipboard || !clipboardItem) {
        return Promise.reject(
            new Error("Image clipboard copy is not supported")
        );
    }

    return clipboard.write([new clipboardItem({ [blob.type]: blob })]);
}

/**
 * Copies the given text to the clipboard using a temporary off-screen
 * textarea and execCommand, which works across the browsers the app targets.
 *
 * @param text The text to place on the clipboard.
 */
export function copyToClipboard(text: string): void {
    const element = document.createElement("textarea");
    element.style.position = "fixed";
    element.style.opacity = "0";
    element.value = text;
    document.body.appendChild(element);
    element.select();
    document.execCommand("copy");
    document.body.removeChild(element);
}
